import { Injectable, inject } from '@angular/core';
import { IAceitarTermo, ITermo, ITermoFiltro } from '@nomoh-monorepo/shared-types';
import { TermosDataService } from './feature-termos.dataservice.service';

@Injectable({ providedIn: 'root' })
export class TermosService {
  private termosDataService = inject(TermosDataService);

  async carregarTermos(): Promise<void> {
    return this.termosDataService.carregarTermos();
  }

  async buscarTermos(filtros: Partial<ITermoFiltro>): Promise<void> {
    return this.termosDataService.buscar(filtros);
  }

  async criarTermo(
    termo: Omit<ITermo, 'id' | 'ativo' | 'dataPublicacao' | 'dataInclusao' | 'dataAlteracao' | 'pessoaInclusao' | 'pessoaAlteracao'>
  ): Promise<ITermo | null> {
    if (!termo.sistemaId) throw new Error('sistemaId é obrigatório');
    if (!termo.titulo?.trim()) throw new Error('Título é obrigatório');
    if (!termo.versao?.trim()) throw new Error('Versão é obrigatória');
    if (!termo.conteudo?.trim()) throw new Error('Conteúdo é obrigatório');
    return this.termosDataService.criarTermo(termo);
  }

  async buscarVigentes(sistemaId: string): Promise<ITermo[]> {
    return this.termosDataService.buscarVigentes(sistemaId);
  }

  async registrarDecisao(dto: IAceitarTermo): Promise<void> {
    return this.termosDataService.registrarDecisao(dto);
  }

  async limparFiltros(): Promise<void> {
    return this.termosDataService.limparFiltros();
  }
}
